/**
 * Escapes text that is about to be interpolated into a markup string.
 *
 * Needed wherever a message is bound as HTML — the shared confirmation dialog
 * (PopupAndNotifService.confirm / confirmAction) and the notification emails — while carrying a
 * value that came from user input or from the database: without escaping, a denomination or a
 * deal title holding `<` is read as markup.
 *
 * Two private copies of this predate the file (`opportunity-deletion-email.util.ts` and
 * `iban-jm-detail-dialog.component.ts`); point them here when either is next touched.
 */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
